// extracted by mini-css-extract-plugin
export default {"rating":"eN-z","numberOfStars":"fN-z","count":"gN-z","barGraphSpacing":"hN-z","barGraph":"iN-z"};